var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/RichText/index.tsx";
import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@adc/parallax-component-library';
import { useDefaultTransComponents } from 'Hooks';
import i18n from 'Utilities/i18n';
const RichText = ({
  text,
  values = {},
  onPressLink,
  customNodes,
  testID,
  ...rest
}) => {
  const defaultTransComponents = useDefaultTransComponents(onPressLink, customNodes);
  return /*#__PURE__*/React.createElement(Trans, Object.assign({
    i18n: i18n,
    defaults: text,
    values: values,
    parent: ({
      children
    }) => /*#__PURE__*/React.createElement(Text, {
      testID: testID,
      color: "$text.100",
      fontSize: "$bodyBase.default",
      fontWeight: "$bodyBase.default",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 9
      }
    }, children),
    components: defaultTransComponents
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }));
};
export { RichText };